import type { Translations } from './types';

export const de: Translations = {
  // Common
  common: {
    backToHome: '← Zur Startseite',
    back: '← Zurück',
    loading: 'Laden...',
    error: 'Fehler',
    save: 'Speichern',
    cancel: 'Abbrechen',
    start: 'Start!',
    pause: 'Pause',
    resume: 'Weiter',
    menu: 'Menü',
    score: 'Punkte',
    rank: 'Rang',
    of: 'von',
    name: 'Name',
    email: 'E-Mail',
    optional: 'optional',
    saving: 'Speichern...',
    scoreSaved: 'Punktestand gespeichert!',
    goodLuck: 'Viel Glück!',
    noScores: 'Noch keine Punktestände',
    highscores: 'Highscores',
  },

  // Navigation
  nav: {
    home: 'Start',
    leaderboard: 'Bestenliste',
  },

  // Home page
  home: {
    hero: 'Industrial Games',
    heroHighlight: ' Platform',
    heroSubtitle: 'Lerne industrielle Automatisierung spielerisch kennen. Kämpfe um den Spitzenplatz in der Bestenliste!',
    viewLeaderboard: '🏆 Bestenliste ansehen',
    chooseGame: 'Wähle dein Spiel',
    topPlayers: '🏆 Top Spieler',
    viewAll: 'Alle ansehen →',
    howItWorks: 'So funktioniert es',
    step1Title: 'Spiel wählen',
    step1Desc: 'Wähle aus unserer Sammlung von Mini-Spielen zum Thema industrielle Automatisierung.',
    step2Title: 'Spielen & Punkten',
    step2Desc: 'Meistere Herausforderungen, sammle Punkte und klettere in der Bestenliste nach oben.',
    step3Title: 'Preise gewinnen',
    step3Desc: 'Top-Tagesergebnisse können tolle Preise gewinnen. Gib deine E-Mail ein, um teilzunehmen!',
    poweredBy: 'Powered by UKONNX',
    cabinetTitle: 'Cabinet Transformer',
    cabinetSubtitle: 'Schaltschrank-Jagd!',
    cabinetDesc: 'Verwandle klassische Schaltschränke in moderne dezentrale Lösungen. Klicke schnell, erziele hohe Punkte!',
    automationTitle: 'Automation Drop',
    automationSubtitle: 'Drag & Drop Challenge',
    automationDesc: 'Ziehe Automatisierungsteile in die richtigen Slots. Baue das perfekte Industriesystem!',
    playNow: 'Jetzt spielen',
  },

  // Leaderboard
  leaderboard: {
    title: 'Bestenliste',
    subtitle: 'Top-Spieler aller UKONNX Spiele',
    allGames: 'Alle Spiele',
    player: 'Spieler',
    game: 'Spiel',
    date: 'Datum',
    noScoresYet: 'Noch keine Punktestände. Sei der Erste!',
    previous: '← Zurück',
    next: 'Weiter →',
    page: 'Seite',
  },

  // Cabinet Transformer Game
  cabinetTransformer: {
    title: 'CABINET Hunter',
    subtitle: '— POWERED BY UKONNX —',
    missionTitle: 'Mission: Zero Cabinet!',
    missionText: 'Verwandle Schaltschränke in dezentrale Lösungen!',
    howToPlay: 'SO SPIELST DU:',
    inst1: 'Klicke auf Schaltschränke um Punkte zu sammeln',
    inst2: '10 verpasste Schaltschränke = Game Over',
    inst3: 'Klicke auf das uKonn-X Logo für Bonuspunkte',
    howToWin: 'SO GEWINNST DU:',
    winText: 'Gib deinen Namen und E-Mail ein, um Tagessieger zu werden und den Preis zu erhalten!',
    startBtn: 'Start!',
    gameFinished: 'Spiel beendet!',
    wellDone: 'Gut gemacht!',
    yourScore: 'DEIN PUNKTESTAND',
    transformedCabinets: 'UMGEWANDELTE SCHALTSCHRÄNKE',
    yourRank: 'DEIN RANG',
    keepHunting: 'Weiter jagen!',
    enterName: 'Dein Name',
    enterEmail: 'E-Mail (optional)',
    saveScore: 'Punktestand speichern',
    timeRemaining: 'Zeit',
    missed: 'Verfehlt',
    autoAim: 'Auto-Ziel',
  },

  // Automation Drop Game
  automationDrop: {
    title: 'AUTOMATION DROP',
    subtitle: '— POWERED BY UKONN-X —',
    mission: 'Mission: Zero Cabinet! Verwandle Schaltschränke in dezentrale Lösungen!',
    howToPlay: 'SO SPIELST DU:',
    inst1: 'Dezentrale Teile anklicken für Punkte',
    inst1Sub: 'Ziehe Bauteile in die Slots',
    inst2: '5 verpasste Teile = Game Over',
    inst3: 'Alte Schaltschränke recyceln',
    inst3Sub: 'Alte Schaltschränke in den Müll',
    howToWin: 'SO GEWINNST DU:',
    winText: 'Gib deinen Namen und E-Mail ein, um Tagessieger zu werden und den Preis zu erhalten!',
    startBtn: 'Start!',
    highscoreBtn: 'Highscore',
    partsLabel: 'Teile:',
    missesLabel: 'Fehler:',
    trashLabel: '🗑️ Recycling',
    gameFinished: 'Spiel beendet!',
    won: 'GEWONNEN!',
    wellDone: 'Gut gemacht!',
    finalScore: 'PUNKTESTAND',
    yourRank: 'DEIN RANG',
    saveScore: 'Weiter gehts!',
    toMenu: 'Zum Menü',
    tooSlow: 'Zu langsam!',
    wrong: 'Falsch!',
    oops: 'Ups!',
    levelUp: 'LEVEL UP! ⚡',
    retroMsg: 'Die 80er wollen ihre Sachen zurück!',
    nope: 'NOPE!',
  },
};
